// extracted by mini-css-extract-plugin
export var smallSpinner = "_wu-0";